import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import BulbIcon from "../images/bulb_icon.svg"
import ComputerIcon from "../images/computer_icon.svg"
import SdmIcon from "../images/sdm_icon.svg"
import { useTranslation } from "react-i18next"

const contents = [
  {
    image: SdmIcon,
    alt: "Sumber Daya Manusia",
    body: "sdm",
  },
  {
    image: ComputerIcon,
    alt: "Digitalisasi",
    body: "computer",
  },
  {
    image: BulbIcon,
    alt: "Inovatif",
    body: "bulb",
  },
]

export default function FlatSection(params) {
  const { t } = useTranslation()
  return (
    <section className="flat-area" id="flat">
      <Container>
        <div className="flat pb-30">
          <Row>
            {contents.map((content, i) => (
              <Col sm={4} key={i}>
                <img
                  src={content.image}
                  alt={content.alt}
                  className="d-block mx-auto mb-4"
                />
                <div className="text-center">
                  <p className="description">{t(content.body)}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  )
}
